
import { Component, Vue } from 'vue-property-decorator';
@Component({
  name: 'ImageViewer',
})
class ImageViewer extends Vue {
  imgVisible = false;
  imgArr = [];
  currImg = '';
  close() {
    this.imgVisible = false;
    setTimeout(() => {
      this.$destroy();
    });
  }
  get isMobile() {
    return !this.$platform.pc;
  }
  mounted() {
    // 解决查看文件消息型图片时，因未知原因在iOS-safari不居中的问题
    // 先完成加载，然后在显示。
    this.$nextTick(() => {
      const showImgSrc = this.imgArr[0];
      console.log('[img-show]', showImgSrc);
      const i = new Image();
      i.onload = () => {
        console.log('[img-load]');
        this.currImg = showImgSrc;
      };
      i.setAttribute('src', showImgSrc);
    });
  }
}
export default ImageViewer;
